import { ref } from "vue";

const isVisible = ref(false);
const message = ref("");
const type = ref("success"); // success | error | info, etc.

let timeoutId = null;

export function useToast() {
  const showToast = (msg, toastType = "success", duration = 3000) => {
    message.value = msg;
    type.value = toastType;
    isVisible.value = true;

    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      isVisible.value = false;
    }, duration);
  };

  const hideToast = () => {
    isVisible.value = false;
    clearTimeout(timeoutId);
  };

  return {
    isVisible,
    message,
    type,
    showToast,
    hideToast,
  };
}
